// Core package exports
export * from './preferences/index.js';
export * from './sensory/index.js';
export * from './cognitive/index.js';
// Note: React hooks are available but require React as peer dependency
// export * from './hooks/index.js';

// Version
export const VERSION = '1.1.0';